{
  "definitions": {
    "intro": "Extra fields for the product form (for example a longer description or the year). What you add here appears in the product form right away.",
    "add": "Add an extra detail",
    "new_title": "New extra detail",
    "drawer_hint": "What staff fill in on the product page. Nothing is published until a product uses it.",
    "save": "Save detail",
    "saved": "\"{{name}}\" saved — the product form shows it now",
    "deleted": "\"{{name}}\" deleted",
    "delete": "Delete",
    "delete_title": "Delete \"{{name}}\"?",
    "delete_consequence": "The field disappears from the product form. If products already have a value, the shop keeps it and does not delete the field.",
    "in_use_title": "This detail is still used",
    "in_use_body_one": "{{count}} product still has a value for this detail, so it was not deleted. Clear the value on that product first.",
    "in_use_body_other": "{{count}} products still have a value for this detail, so it was not deleted. Clear the value on those products first.",
    "in_use_ok": "OK",
    "type_in_use_one": "{{count}} product already has a value, so the kind of answer cannot change. Keep the old kind or make a new detail.",
    "type_in_use_other": "{{count}} products already have a value, so the kind of answer cannot change. Keep the old kind or make a new detail.",
    "type_change_warning": "You are changing the kind of answer. If products already have a value, the shop refuses the change and tells you how many.",
    "duplicate_key": "A detail with this code name already exists. Choose another code name.",
    "all_types": "All kinds",
    "position_cell": "{{position}} (part {{part}} of the form)",
    "columns": {
      "label": "Name",
      "key": "Code name",
      "type": "Kind of answer",
      "owner": "Belongs to",
      "position": "Place in the form",
      "applies_to": "Shown for",
      "ebay": "eBay name"
    },
    "flags_short": {
      "filterable": "Filter on the shop",
      "searchable": "Searchable",
      "showOnStorefront": "Shown on the shop"
    },
    "flags": {
      "filterable": "Customers can filter by it on the shop",
      "searchable": "The shop search finds products by it",
      "showOnStorefront": "Show it on the product page of the shop"
    },
    "fields": {
      "label_en": "Name (English)",
      "label_en_hint": "What staff see above the box, e.g. \"Detail\".",
      "label_ja": "Name (Japanese)",
      "label_th": "Name (Thai)",
      "label_zh-Hant": "Name (Chinese, traditional)",
      "label_zh-Hans": "Name (Chinese, simplified)",
      "key": "Code name",
      "key_hint": "Filled in from the English name. Saved as {{key}} — used in files you import.",
      "key_locked": "The code name cannot change after saving (files and products use it).",
      "owner": "Belongs to",
      "type": "Kind of answer",
      "position": "Place in the product form",
      "position_hint": "A number. 5 = next to the sub-category; other numbers = in part {{part}} \"Details\". Smaller numbers come first.",
      "position_hint_other": "A number; smaller numbers come first.",
      "applies_to": "Shown for these kinds of products",
      "applies_to_hint": "Nothing ticked = every kind.",
      "use": "On the shop",
      "rules": "Rules for the answer",
      "ebay_aspect": "Name on eBay (for later)",
      "ebay_aspect_hint": "Only kept for when eBay is connected in a later phase. Nothing is sent now."
    },
    "owners": {
      "product": "The product",
      "variant": "Each choice of a product (box, pack…)",
      "collection": "A collection page"
    },
    "types": {
      "single_line_text": "Short text (one line)",
      "multi_line_text": "Longer text (several lines)",
      "rich_text": "Formatted text (bold, lists)",
      "integer": "Whole number",
      "decimal": "Number with decimals",
      "boolean": "Yes / no",
      "date": "Date",
      "url": "Web address (link)",
      "json": "Structured data (advanced)",
      "list_text": "List of short texts",
      "file_reference": "One file or picture",
      "list_file_reference": "Several files or pictures",
      "reference": "Link to another product"
    },
    "rules": {
      "required": "Must be filled in before a product can be saved",
      "choices": "Allowed answers",
      "choices_hint": "One per line. Empty = anything may be written.",
      "min": "Smallest number",
      "max": "Largest number",
      "max_length": "Longest text (characters)",
      "regex": "Pattern the text must follow",
      "regex_hint": "Advanced — leave empty if unsure.",
      "max_items": "Most items in the list"
    },
    "problems": {
      "required": "Please fill this in.",
      "key_format": "Use small letters a–z, numbers and _ only, starting with a letter.",
      "position_range": "Use a number from 0 to 999.",
      "not_number": "Write a number, e.g. 8.",
      "min_above_max": "The largest number must not be smaller than the smallest.",
      "not_whole": "Write a whole number, e.g. 200.",
      "pattern_invalid": "This pattern cannot be read. Leave it empty if unsure.",
      "choices_not_whole": "Every allowed answer must be a whole number."
    }
  },
  "categories": {
    "intro": "Groups of products on the shop (up to 3 levels, e.g. Sealed products › Booster boxes). Change the order with ▲ ▼.",
    "add": "Add a category",
    "new_title": "New category",
    "save": "Save category",
    "saved": "Category \"{{name}}\" saved",
    "deleted": "Category \"{{name}}\" deleted",
    "delete": "Delete",
    "delete_title": "Delete the category \"{{name}}\"?",
    "delete_consequence": "The category disappears from the shop menu. Categories that still have products or sub-categories are not deleted.",
    "in_use_title": "This category is still used",
    "in_use_body": "It still has {{products}} product(s) and {{children}} sub-category(ies). Move them to another category first — or hide this one instead.",
    "too_deep": "Categories can be at most {{max}} levels deep. Choose a higher parent.",
    "duplicate": "Another category already uses this name in the web address. Change it a little.",
    "top_level": "— Top level (no parent) —",
    "shown": "Shown",
    "hidden": "Hidden",
    "move_up": "Move {{name}} up",
    "move_down": "Move {{name}} down",
    "add_child": "Add a category under {{name}}",
    "columns": {
      "name": "Name",
      "slug": "Name in the web address",
      "applies_to": "For",
      "active": "On the shop",
      "order": "Order"
    },
    "fields": {
      "name_en": "Name (English)",
      "name_ja": "Name (Japanese)",
      "name_th": "Name (Thai)",
      "name_zh-Hant": "Name (Chinese, traditional)",
      "name_zh-Hans": "Name (Chinese, simplified)",
      "slug": "Name in the web address",
      "slug_hint": "Filled in from the English name: …/collections/{{name}}",
      "parent": "Inside which category",
      "parent_hint": "Leave on \"top level\" for a main category.",
      "applies_to": "For these kinds of products",
      "applies_to_hint": "The product form offers this category only for the ticked kinds. Nothing ticked = every kind.",
      "active": "Show this category on the shop"
    },
    "problems": {
      "required": "Please fill this in.",
      "slug_format": "Use small letters a–z, numbers and - only (no spaces)."
    }
  },
  "brands": {
    "intro": "Makers of the products (card sleeves, deck boxes…), with their logo.",
    "add": "Add a brand",
    "new_title": "New brand",
    "save": "Save brand",
    "saved": "Brand \"{{name}}\" saved",
    "deleted": "Brand \"{{name}}\" deleted",
    "delete": "Delete",
    "delete_title": "Delete the brand \"{{name}}\"?",
    "delete_consequence": "The brand disappears. Brands that products still use are not deleted.",
    "in_use_title": "This brand is still used",
    "in_use_body_one": "{{count}} product still uses this brand, so it was not deleted.",
    "in_use_body_other": "{{count}} products still use this brand, so it was not deleted.",
    "duplicate": "A brand with this name in the web address already exists.",
    "has_logo": "Logo",
    "no_logo": "No logo",
    "updated": "Last changed",
    "fields": {
      "name": "Brand name",
      "logo": "Logo"
    }
  }
}
